import VisibilityModalContainer from './visibility_modal_container';

const VisibilityModal = VisibilityModalContainer;

export default VisibilityModal;
